import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { NavigationProgress, nprogress } from '@mantine/nprogress';
import useHeaderStore from '@/store/header';

export function RouterTransition() {
  const router = useRouter();
  const { setRouterState, openNavPanel } = useHeaderStore(({ setRouterState, openNavPanel }) => ({
    setRouterState,
    openNavPanel,
  }));

  useEffect(() => {
    const handleStart = (url: string) => url !== router.asPath && nprogress.start();
    const handleComplete = () => {
      nprogress.complete();
      openNavPanel(false);
    };
    if (!(router.asPath === '/sign-in') && !(router.asPath === '/404') && !(router.asPath === '/sign-out')) {
      setRouterState(router.asPath);
    }
    router.events.on('routeChangeStart', handleStart);
    router.events.on('routeChangeComplete', handleComplete);
    router.events.on('routeChangeError', handleComplete);
    return () => {
      router.events.off('routeChangeStart', handleStart);
      router.events.off('routeChangeComplete', handleComplete);
      router.events.off('routeChangeError', handleComplete);
    };
  }, [router.asPath]);

  return <NavigationProgress autoReset={true} color="#E1252A" size={5} />;
}
